import { render, staticRenderFns } from "./CreateManualTransactionModal.vue?vue&type=template&id=3c6ecc48&"
import script from "./CreateManualTransactionModal.vue?vue&type=script&lang=js&"
export * from "./CreateManualTransactionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports